import { ProductDto, ProductType } from 'common/api/autogenerated/client-area';
import { CustomerSubscriptionDto } from 'common/api/autogenerated/client-area/models/CustomerSubscriptionDto';

import { EarnSubscription } from '../list/components/Subscriptions/types';

/**
 * The function `mapProductsFromServer` filters out products with a currency code containing 'TEST'.
 * @param {ProductDto[]} products - An array of ProductDto objects.
 */
export const mapProductsFromServer = (products: ProductDto[]): ProductDto[] =>
  products
    .filter((_product) => !_product.currencyCode?.includes('TEST'))
    .sort((left, right) => Number(right.interestRate) - Number(left.interestRate));

/**
 * The function `mapEarnSubscriptionsFromServer` sorts an array of subscription objects based on their
 * `closedOn` date in descending order (from new to old).
 * @param {CustomerSubscriptionDto[]} _subscriptions - The `_subscriptions` parameter is an array of
 * `CustomerSubscriptionDto` objects.
 */
export const mapEarnSubscriptionsFromServer = (
  _subscriptions: CustomerSubscriptionDto[] | null | undefined = [],
  products: ProductDto[] = [],
): EarnSubscription[] =>
  !_subscriptions
    ? []
    : [..._subscriptions]
        .sort((left, right) => new Date(right.createdOn || '').getTime() - new Date(left.createdOn || '').getTime())
        .map((subscription) => {
          const product = products.find((_product) => _product.id === subscription.productId) || {};

          const interestRate =
            subscription.interestRate ?? (subscription.productType === ProductType.FLEX ? product.interestRate : 0);

          return {
            currencyName: product.currencyName,
            ...subscription,
            interestRate,
            autoSubscribeEnabled: product.autoSubscribeEnabled,
          };
        });

/**
 * The function `mapEarnHistoryFromServer` sorts an array of subscription objects based on their
 * `closedOn` date in descending order (from new to old).
 * @param {CustomerSubscriptionDto[]} _subscriptions - The `_subscriptions` parameter is an array of
 * `CustomerSubscriptionDto` objects.
 */
export const mapEarnHistoryFromServer = (
  _subscriptions: CustomerSubscriptionDto[] | null | undefined = [],
  products: ProductDto[] = [],
): EarnSubscription[] =>
  !_subscriptions
    ? []
    : [..._subscriptions]
        .sort((left, right) => new Date(right.createdOn || '').getTime() - new Date(left.createdOn || '').getTime())
        .map((subscription) => {
          const product = products.find((_product) => _product.id === subscription.productId) || {};

          const interestRate = subscription.interestRate ?? 0;

          return {
            interestRate,
            currencyName: product.currencyName,
            ...subscription,
          };
        });
